<template>
  <v-card
    :style="!mobile ? 'width: 80%' : ''"
    class="mx-auto entry-container"
    elevation="11"
  >
    <v-card-title class="justify-content-center">{{
      $route.name === "SlotListToday"
        ? "Todays Booked Slots"
        : "Facility Reporting"
    }}</v-card-title>
    <hr />
    <v-card
      :style="
        !mobile ? 'width: 80%; margin-left:10%; margin-top: 6%;' : 'width 100%;'
      "
      elevation="11"
      :class="mobile ? 'p-3' : 'p-0'"
    >
      <v-card-title
        class="justify-content-center"
        v-if="$route.name !== 'SlotListToday'"
        >Search Date Ranges</v-card-title
      >
      <v-row
        :class="
          mobile
            ? 'p-0 w-100 justify-space-between'
            : 'p-5 m-2 w-100 justify-space-between'
        "
        v-if="$route.name !== 'SlotListToday'"
      >
        <v-col :cols="mobile ? '12' : '4'">
          <v-menu
            v-model="startMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedSearchDateStartFormatted"
                label="Select Start Date* "
                prepend-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="en-gb"
              no-title
              scrollable
              v-model="searchStart"
              @input="startMenu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col :cols="mobile ? '12' : '4'">
          <v-menu
            v-model="endMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedSearchDateEndFormatted"
                label="Select End Date* "
                prepend-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              locale="en-gb"
              v-model="searchEnd"
              no-title
              scrollable
              @input="endMenu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col :cols="mobile ? '12' : '2'">
          <v-row
            :class="
              !mobile
                ? 'justify-space-around mt-2'
                : 'justify-content-center mt-2'
            "
          >
            <v-btn
              :class="!mobile ? 'mt-2 ml-3' : ' mt-2'"
              color="success"
              @click="getSlotsByStatus(status)"
              >Search</v-btn
            >
            <v-btn
              :class="!mobile ? 'mt-2 mr-4' : ' mt-2 ml-1'"
              color="red"
              @click="reset()"
              >Clear</v-btn
            >
          </v-row>
        </v-col>
        <v-col :cols="'12'">
          <v-alert
            v-if="validationError"
            class="text-center m-1 mb-0"
            color="red"
            dark
            :icon="false"
            type="error"
            dense
            outlined
            >Please Provide A Valid Date Range To Search</v-alert
          >
        </v-col>
      </v-row>
      <hr />
      <v-row
        class="p-4 w-100 justify-space-between"
        v-if="$route.name !== 'SlotListToday' && searched"
      >
        <v-col :cols="mobile ? '12' : '3'">
          <v-select
            :items="items"
            label="Status"
            @change="getSlotsByStatus(status)"
            v-model="status"
          ></v-select>
        </v-col>
        <v-col :cols="mobile ? '12' : '6'">
          <h5 class="text-center mt-4" v-if="slots.length">
            Slots Count: {{ slots.length }}
          </h5>
        </v-col>

        <v-col :cols="mobile ? '12' : '3'">
          <v-select
            label="Select a Facility"
            v-model="facility"
            @change="getSlotsByStatus(status)"
            :items="facilityOptions"
          />
        </v-col>
      </v-row>

      <v-data-table
        v-if="
          ($route.name !== 'SlotListToday' && searched) ||
            $route.name === 'SlotListToday'
        "
        id="slot_table"
        :headers="status === 'Available' ? availHeaders : headers"
        :items="slots"
        :items-per-page="20"
        class="elevation-1 p-4"
      />
      <v-card-actions
        v-if="
          ($route.name !== 'SlotListToday' && searched) ||
            $route.name === 'SlotListToday'
        "
        :class="mobile ? 'justify-content-center' : 'pt-3'"
      >
        <vue-json-to-csv
          :json-data="formattedSlots"
          :csv-title="`TFSC-Reporting-${Math.floor(Math.random() * 6000)}`"
        >
          <v-btn color="success" class="mr-6">
            Export <i class="mdi mdi-export-variant" aria-hidden="true"></i>
          </v-btn>
        </vue-json-to-csv>
        <v-btn color="info" class="mr-6" v-print="'#slot_table'">Print</v-btn>
      </v-card-actions>
    </v-card>
  </v-card>
</template>
<script>
import VueJsonToCsv from "vue-json-to-csv";
import moment from "moment";
import {
  getSlotsByStatus,
  fetchFacilities,
  getSlotsById
} from "../../services/FacilityService";
export default {
  name: "SlotsList",
  components: { VueJsonToCsv: VueJsonToCsv },
  data: () => ({
    searched: false,
    startMenu: false,
    endMenu: false,
    searchStart: null,
    searchEnd: null,
    headers: [
      {
        value: "start_time",
        sortable: true,
        text: "Date",
        class: "date_width"
      },
      {
        value: "status",
        sortable: true,
        text: "Status",
        _rowVariant: "danger"
      },
      {
        value: "facilityName",
        text: "Facility Name",
        sortable: true
      },
      {
        value: "customer_data.name",
        text: "Booking Name",
        sortable: true
      }
    ],
    availHeaders: [
      {
        value: "start_time",
        sortable: true,
        text: "Date",
        class: "date_width"
      },
      {
        value: "status",
        sortable: true,
        text: "Status",
        _rowVariant: "danger"
      },
      {
        value: "duration",
        sortable: true,
        text: "Duration",
        _rowVariant: "danger"
      }
    ],
    slots: [],
    status: "Booked",
    items: ["Booked", "Available", "Pending", "Hold"],
    mobile: window.innerWidth <= 1200,
    facility: "",
    facilities: [],
    facilityOptions: [],
    validationError: false
  }),
  computed: {
    computedSearchDateEndFormatted() {
      return this.searchEnd
        ? moment(this.searchEnd).format("dddd, MMMM Do YYYY")
        : "";
    },
    computedSearchDateStartFormatted() {
      return this.searchStart
        ? moment(this.searchStart).format("dddd, MMMM Do YYYY")
        : "";
    },
    formattedSlots() {
      return [...this.slots].map(slotData => {
        let obj = {};
        obj.id = slotData._id ? slotData._id : "";
        obj.blockBooking = slotData.blockBooking ? "Y" : "N";
        obj.status = slotData.status ? slotData.status : "";
        obj.duration = slotData.duration ? slotData.duration : "";
        obj.intNotes = slotData.intNotes ? slotData.intNotes : "";
        obj.extNotes = slotData.extNotes ? slotData.extNotes : "";
        obj.facilityId = slotData.facilityId ? slotData.facilityId : "";
        obj.facilitySubId = slotData.facilitySubId
          ? slotData.facilitySubId
          : "";
        obj.facilitySport = slotData.facilitySport
          ? slotData.facilitySport
          : "";
        obj.facilitySize = slotData.facilitySize ? slotData.facilitySize : "";
        obj.facilityName = slotData.facilityName ? slotData.facilityName : "";
        obj.totalAmount = slotData.totalAmount ? slotData.totalAmount : "";
        obj.transactionStatus = slotData.transactionStatus
          ? slotData.transactionStatus
          : "";
        obj.transactionType = slotData.transactionType
          ? slotData.transactionType
          : "";
        obj.transactionId = slotData.transactionId
          ? slotData.transactionId
          : "n/a";
        obj.transactionLink = slotData.transactionLink
          ? slotData.transactionLink
          : "n/a";

        obj.customer_name = slotData.customer_data.name
          ? slotData.customer_data.name
          : "";
        obj.customer_marketing = slotData.customer_data.marketing
          ? slotData.customer_data.marketing
          : "";
        obj.occupancy = slotData.customer_data.occupancy
          ? slotData.customer_data.occupancy
          : "";
        obj.start_time = moment(slotData.start_time).format("DD MM YYYY HH:mm");
        obj.end_time = moment(slotData.end_time).format("DD MM YYYY HH:mm");

        return obj;
      });
    }
  },
  created() {
    addEventListener("resize", () => {
      this.mobile = innerWidth <= 1200;
    });
  },
  async mounted() {
    await this.getFacilites();
    if (this.$route.name === "SlotListToday") {
      this.getTodaysSlots();
    }
  },
  methods: {
    async getSlotsByStatus(status) {
      this.searched = false;
      this.validationError = false;

      let data = {
        facilityId: this.facility
      };
      if (
        !this.searchStart ||
        !this.searchEnd ||
        new Date(this.searchStart) > new Date(this.searchEnd)
      ) {
        this.validationError = true;
        setTimeout(() => {
          this.validationError = false;
        }, 6000);
        return;
      }
      if (this.searchStart) {
        data.searchStart = this.searchStart;
      }
      if (this.searchEnd) {
        data.searchEnd = this.searchEnd;
      }
      let res = await getSlotsByStatus(status, data);
      if (res.error) {
        this.text = "An internal server error occurred. Please try later.";
      }
      this.slots = res.map(slot => {
        slot.start_time = moment(slot.start_time).format("DD-MMM-YYYY kk:mm");
        return slot;
      });
      this.slots = res.sort((a, b) => {
        if (a.title < b.title) {
          return -1;
        }
        if (a.title > b.title) {
          return 1;
        }
        return 0;
      });
      this.searched = true;
    },
    async getFacilites() {
      let res = await fetchFacilities();
      this.isBusy = false;
      if (res.error) {
        this.text = "An internal server error occurred. Please try later.";
      }
      this.facilities = [...res.data];
      this.facilityOptions = res.data.map(facility => {
        return { text: facility.title, value: facility.facilityId };
      });

      // Default to first item in array
      this.facility = this.facilityOptions[0].value;
    },
    async getTodaysSlots() {
      let res = await getSlotsById("today");
      this.isBusy = false;
      if (res.error) {
        this.text = "An internal server error occurred. Please try later.";
      }

      this.slots = res.sort((a, b) => {
        a.start_time = moment(a.start_time).format("DD-MMM-YYYY kk:mm");
        b.start_time = moment(b.start_time).format("DD-MMM-YYYY kk:mm");
        if (a.title < b.title) {
          return -1;
        }
        if (a.title > b.title) {
          return 1;
        }
        return 0;
      });
      this.total_rows = res.length;
    },
    reset() {
      this.searched = false;
      this.slots = [];
      this.searchStart = null;
      this.searchEnd = null;
    }
  }
};
</script>
